export default __webpack_public_path__ + "static/media/img-08.472512ef.png";